import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "JamaalStore - Parfums Authentiques, Musc & Huiles Essentielles au Sénégal",
  description = "Découvrez notre collection de parfums authentiques, musc, huiles essentielles et fragrances de luxe. Livraison rapide à Dakar et partout au Sénégal.",
  keywords = "parfum Sénégal, parfum Dakar, musc Sénégal, huile essentielle Sénégal, parfum oriental, parfum arabe",
  image = "https://jamaalstore.com/images/og-image.jpg",
  url = "https://jamaalstore.com",
  type = "website",
  product = null
}) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="JamaalStore" />
      <meta property="og:locale" content="fr_SN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Product Schema if provided */}
      {product && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": product.name,
            "image": product.image,
            "description": product.description,
            "brand": {
              "@type": "Brand",
              "name": "JamaalStore"
            },
            "offers": {
              "@type": "Offer",
              "url": url,
              "priceCurrency": "XOF",
              "price": product.price,
              "priceValidUntil": "2026-12-31",
              "availability": product.inStock ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
              "seller": {
                "@type": "Organization",
                "name": "JamaalStore"
              }
            },
            ...(product.rating && {
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": product.rating.value,
                "reviewCount": product.rating.count
              }
            })
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
